var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.576 17.808a.94.94 0 0 1 .721.053 6.941 6.941 0 0 0 3.149.745 7.054 7.054 0 0 0 6.307-3.903 6.94 6.94 0 0 0 .746-3.147l.001-.421c-.197-3.58-3.056-6.439-6.584-6.635h-.472a6.944 6.944 0 0 0-3.15.747 7.054 7.054 0 0 0-3.9 6.309 6.94 6.94 0 0 0 .745 3.147.94.94 0 0 1 .053.721L5 19l3.576-1.192zm11.52-2.437a8.548 8.548 0 0 1-11.124 3.986l-4.786 1.595a.9.9 0 0 1-1.138-1.138l1.595-4.786A8.548 8.548 0 0 1 8.625 3.906 8.44 8.44 0 0 1 12.451 3l.5.001c4.341.24 7.808 3.707 8.049 8.098v.45a8.438 8.438 0 0 1-.905 3.822z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.96d8a798.svg";
export { ForwardRef as ReactComponent };